// app/(styles)/ThemeProvider.tsx
'use client';

import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import createTheme from '@mui/material/styles/createTheme';
import themeOptions from '@styles/theme';

const theme = createTheme(themeOptions);

export default function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}